import { Investment } from "./models";

export const mockInvestments: Investment[] = [];
